import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_DOCUMENT_DOWNLOAD, GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT,} from '../../constants/apiUrls';
import {
  GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT_QUERY_KEY,
  GET_DOCUMENT_DOWNLOAD_QUERY_KEY,
} from '../../constants/queryKeys';
import {RetrieveS3URLResponse} from '../../api/document/files/api-services/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================

interface Input {
  uuid: string;
  enabled: boolean;
  onSuccess?: (data: RetrieveS3URLResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDocumentDownload = ({onSuccess, onError, uuid, enabled = false}: Input) => {
  const getDocumentDownload = async () => {
    const res = await axiosClient.get<RetrieveS3URLResponse>(GET_DOCUMENT_DOWNLOAD(uuid));
    return res.data;
  };

  return useCustomQuery(
      GET_DOCUMENT_DOWNLOAD_QUERY_KEY,
      getDocumentDownload,
      {
        onSuccess,
        onError,
        retryOnMount: true,
        refetchOnWindowFocus: true,
        cacheTime: 0,
        enabled,
      },
      false,
      false
  );
};

export const useGetDocumentDownloadAsAttachment = ({
                                                     onSuccess,
                                                     onError,
                                                     uuid,
                                                     enabled = false,
                                                   }: Input) => {
  const getDocumentDownloadAsAttachment = async () => {
    const res = await axiosClient.get<RetrieveS3URLResponse>(
        GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT_QUERY_KEY,
      getDocumentDownloadAsAttachment,
      {
        onSuccess,
        onError,
        retryOnMount: true,
        refetchOnWindowFocus: true,
        cacheTime: 0,
        enabled,
      },
      false,
      false
  );
};
